import React from 'react';

const ranges = [
    { value: 'all', label: 'All scores' },
    { value: 'excellent', label: 'Excellent (80–100)' },
    { value: 'good', label: 'Good (60–79)' },
    { value: 'average', label: 'Average (40–59)' },
    { value: 'poor', label: 'Below 40' },
];

// Multi-select: selectedScoreRanges is an array of range keys; empty = all scores.
const JobHeaderScoreFilter = ({ selectedScoreRanges = [], setSelectedScoreRanges }) => {
    const toggle = (value) => {
        if (value === 'all') {
            setSelectedScoreRanges([]);
            return;
        }
        setSelectedScoreRanges(prev =>
            prev.includes(value) ? prev.filter(v => v !== value) : [...prev, value]
        );
    };

    return (
        <div className="flex flex-wrap gap-2">
            {ranges.map(r => {
                const active = r.value === 'all'
                    ? selectedScoreRanges.length === 0
                    : selectedScoreRanges.includes(r.value);
                return (
                    <button
                        key={r.value}
                        type="button"
                        onClick={() => toggle(r.value)}
                        className={`px-4 py-2 rounded-lg text-[13px] font-medium border transition-all ${
                            active
                                ? 'bg-[#EEF1FE] border-[#3F57E0] text-[#3F57E0]'
                                : 'bg-white border-gray-200 text-gray-600 hover:border-gray-300 hover:bg-gray-50'
                        }`}
                    >
                        {r.label}
                    </button>
                );
            })}
        </div>
    );
};

export default JobHeaderScoreFilter;
